import type { IsKalemi } from "./api";

/**
 * Is listesindeki her tur, DOGRUDAN ilgili ekrani aciyor (F-ANL-09 —
 * "ogrenci secme ekranina donulmez"). Kapsanmayan bir tur programa
 * dusuyor: yanlis ekran acmak, hicbir sey acmamaktan iyidir.
 *
 * Ayri modulde (05.10.2026, urun incelemesi H1): esleme `Uygulama.tsx`
 * icinde test edilemez duruyordu ve "gorusme raporu yazilmamis" kalemi
 * PROGRAM ekranini aciyordu; sunucu hedefi `/ogrenciler/:id/gorusmeler`
 * (analiz.service). Koc rapor yazacagi gorusmeyi programda ariyordu.
 * Hedef ekranlarin hepsi ogrenci baglamli (`OGRENCI_EKRANLARI`): secili
 * ogrenci korunur.
 */
export const IS_TURU_EKRANI: Record<IsKalemi["tur"], string> = {
  VERI_GIRMEYEN: "program",
  PROGRAM_HAZIRLANMAMIS: "program",
  GORUSME_RAPORU_YAZILMAMIS: "kocluk",
  VELI_RAPORU_BEKLIYOR: "raporlar",
  // "Net düşen" uyarısının cevabı deneme analizinde: hangi konularda
  // düştüğünü görmeden program yazmak, körlemesine telafi olurdu.
  NET_DUSEN: "denemeler",
};
